import {
  AppNavigation as AppNavigationPhase1,
  useIsFoundationalPillarsNavPhase1Enabled,
} from '@ms/yammer-features-app-navigation';
import AppNavigation from '@ms/yammer-web-components/dist/navigation/AppNavigation';
import NavigationCommunities from '@ms/yammer-web-components/dist/navigation/NavigationCommunities';
import React, { ReactNode, useCallback } from 'react';

import { useHomeLinkActionButtons } from './useHomeLinkActionButtons';
import { useUserProfileLinkActionButtons } from './useUserProfileLinkActionButtons';

type UseGetNavigationCallback = () => () => ReactNode;
export const useGetNavigationCallback: UseGetNavigationCallback = () => {
  const isFoundationalPillarsNavPhase1Enabled = useIsFoundationalPillarsNavPhase1Enabled();
  const userProfileLinkActionButtons = useUserProfileLinkActionButtons();
  const homeLinkActionButtons = useHomeLinkActionButtons();

  return useCallback(
    () =>
      isFoundationalPillarsNavPhase1Enabled ? (
        <AppNavigationPhase1
          communitiesNavLinksContent={<NavigationCommunities />}
          userProfileLinkActionButtons={userProfileLinkActionButtons}
          homeLinkActionButtons={homeLinkActionButtons}
        />
      ) : (
        <AppNavigation />
      ),
    [homeLinkActionButtons, isFoundationalPillarsNavPhase1Enabled, userProfileLinkActionButtons]
  );
};
